export default __webpack_public_path__ + "static/media/achive2.38b3b05c.jpg";